import React from 'react';
import { I18nContextProvider } from '@ecg-internal/js-react-i18n';
import { hydrateRoot } from 'react-dom/client';
import { Header } from '@hz-design-system/web-ui';

import CarsPageContentApp from '../../apps/CarsPageContent/CarsPageContent';
import CarsCategoryLinksApp from '../../apps/CarsCategoryLinks/CarsCategoryLinksApp';

import { trackGAEvent } from '../../utils/gaTracking';

import '../../../scss/l1CarsPage.scss';
// server side only components styles for this page
import '../../../../server/pages/l1CarsPage.styles';
import { TEnvConfigCars } from 'types/TServerContext';

// eslint-disable-next-line require-await
export default async (i18n) => {
  const appState = window.__CONFIG__ || {
    carsCategoryLinks: [],
  };
  const environment = (window.__ENV_CONFIG__ as TEnvConfigCars) || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const categoryLinksRoot = document.getElementById('category-links-root');
  const pageContentRoot = document.getElementById('page-wrapper');

  // Header is server side rendered in express-react library
  hydrateRoot(headerRoot!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  hydrateRoot(
    pageContentRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <CarsPageContentApp appState={appState} environment={environment} />
    </I18nContextProvider>,
  );

  hydrateRoot(
    categoryLinksRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <CarsCategoryLinksApp carsCategoryLinks={appState.carsCategoryLinks} environment={environment} />
    </I18nContextProvider>,
  );
};
